import React, { useState } from 'react'
import { Popover } from 'antd'
import WizrButton from '../WizrButton'
import MoreIcon from '../../assets/icons/More'
import EditIcon from '../../assets/icons/EditIcon'
import { dispatchEnableDisableUser, dispatchListUsers, dispatchDeleteUser, dispatchEmailInvite } from '../../redux/actions/content'
import { useNavigate } from 'react-router-dom'
import WizrFlexLayout from '../../components/WizrFlexLayout'
import DeleteIcon from '../../assets/icons/DeleteIcon'
import { MODAL_TYPES, useWizrModalContext } from '../../providers/modal/WizrModalProvider'
import styled from 'styled-components'
import { useAuth } from '../../authContext'
import DisableIcon from '../../assets/icons/Disable'
import MailInvitation from '../../assets/icons/MailInvitation'
import Reactivate from '../../assets/icons/Reactivate'

const UserActionPopoverContent = (user: any): JSX.Element => {
  const navigate = useNavigate()
  const userDetails = user?.user
  const { showModal, hideModal } = useWizrModalContext()
  const { hasAcces } = useAuth()
  const isUserActive = userDetails?.accountEnabled

  const disabledStyle = {
    color: '#B8BBBF',
    cursor: 'not-allowed',
    '&:hover': {
      backgroundColor: '#B8BBBF'
    }
  }

  const deactivateUser = async () => {
    if (!isUserActive) return
    user?.onClosePopover?.()
    const payload = {
      user_id: userDetails?.id,
      activation_status: "disable"
    }
    await dispatchEnableDisableUser(payload)
    dispatchListUsers(`tenant&tenant_id=${userDetails?.typeTenant}`)
  }

  const reactivateUser = async () => {
    if (isUserActive) return
    user?.onClosePopover?.()
    const payload = {
      user_id: userDetails?.id,
      activation_status: "enable"
    }
    await dispatchEnableDisableUser(payload)
    dispatchListUsers(`tenant&tenant_id=${userDetails?.typeTenant}`)
  }

  const resendInvitation = async () => {
    user?.onClosePopover?.()
    const payload = {
      user_id: userDetails?.id,
      email: userDetails?.mail,
      name: userDetails?.displayName,
    }
    console.log("userDetails", userDetails)
    console.log("payload for email invite", payload)
    await dispatchEmailInvite(payload)
  }

  const editUserDetails = () => {
    user?.onClosePopover?.()
    navigate('/userdetails', {
      state: {
        action: userDetails,
        tenant: {
          value: userDetails?.typeTenant,
          label: ""
        }
      }
    })
  }

  const onDeleteAction = async () => {
    user?.onClosePopover?.()
    showModal(MODAL_TYPES.CONFIRMATION, {
      text: `Are you sure you want to delete ${userDetails?.displayName}`,
      buttontext: "Confirm",
      onConfirm: onDeleteUser,
      onCancel: hideModal
    })
  }

  const onDeleteUser = async () => {
    hideModal()
    await dispatchDeleteUser(userDetails?.id)
    dispatchListUsers(`tenant&tenant_id=${userDetails?.typeTenant}`)
  }

  return (
    <WizrFlexLayout textAlign='left' background='#FFF'>
      <WizrButton
        icon={<MailInvitation />}
        text='Resend Invitation'
        type='text'
        onClick={resendInvitation}
        justifyContent='flex-start'
        disabled={!hasAcces('edit_users')}
      />
      <WizrButton
        icon={<EditIcon />}
        text='Edit User'
        type='text'
        onClick={editUserDetails}
        justifyContent='flex-start'
        disabled={!hasAcces('edit_users')}
      />
      <WizrButton
        icon={<DisableIcon />}
        text='Deactivate User'
        type='text'
        onClick={deactivateUser}
        justifyContent='flex-start'
        disabled={!isUserActive || !hasAcces('edit_users')}
        style={!isUserActive ? disabledStyle : {}}
      />
      <WizrButton
        icon={<Reactivate />}
        text='Reactivate User'
        type='text'
        onClick={reactivateUser}
        justifyContent='flex-start'
        disabled={isUserActive || !hasAcces('edit_users')}
        style={isUserActive ? disabledStyle : {}}
      />
      <WizrButton
        icon={<DeleteIcon />}
        text='Delete User'
        type='text'
        onClick={onDeleteAction}
        justifyContent='flex-start'
        disabled={!hasAcces('delete_users')}
      />
    </WizrFlexLayout>
  )
}

const UserActionPopOver = (userDetails: any): JSX.Element => {
  const user = userDetails?.userDetails
  const [popoverOpen, setPopoverOpen] = useState(false)

  return (
    <Popover
      content={
        <UserActionPopoverContent
          user={user}
          onClosePopover={() => setPopoverOpen(false)}
        />
      }
      trigger='click'
      open={popoverOpen}
      onOpenChange={setPopoverOpen}
    >
      <StyledButton icon={<MoreIcon />} text='' type='text' style={{ height: '40px', width: '40px', borderRadius: '50px' }} />
    </Popover>
  )
}

export default UserActionPopOver

const StyledButton = styled(WizrButton)`
border-radius: 50%;
width: 20px;
height: 20px;
padding-right: 8px;
justify-content: center;
align-items: center;
  /* Default styles */
  path {
    stroke: #999B9F; /* Default stroke color */
    transition: stroke 0.3s ease; /* Smooth transition for color change */
  }

  /* Hover styles */
  &:hover path {
    stroke: #1D1F22
  }
`;